import { useEffect, useState } from 'react';
import { tooltipAtom } from '..';
import { useAtomValue } from 'jotai';
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import RouteTooltip from './RouteTooltip';

export default function CustomTooltip(): JSX.Element | undefined {
  const tooltip = useAtomValue(tooltipAtom);

  const [targetComp, setTargetComp] = useState<JSX.Element | undefined>();

  useEffect(() => {
    if (tooltip) {
      switch (tooltip.type) {
        case 'route':
          setTargetComp(<RouteTooltip routeInfo={tooltip} />);
          break;
        // case 'dest':
        //   setTargetComp(<DestTooltip />);
        //   break;
        default:
          setTargetComp(undefined);
          break;
      }
    } else {
      setTargetComp(undefined);
    }
  }, [tooltip]);

  return targetComp;
}

export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom-start" />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'transparent',
    maxWidth: '40rem',
    margin: '1rem',
  },
}));
